import { add, qs, remove } from "@fluorescent/dom";

import { section } from "@/neon";
import { emit } from "@/neon/events";
import { animateGrid } from "@/lib/animation";
import { Ajaxinate } from "ajaxinate";

import sidebar from "@/lib/collection/sidebar";
import mobileFiltering from "@/lib/collection/mobile-filtering";
import filterHandler from "@/lib/filters/filter-handler";

const sel = {
  content: "[data-js-container]",
  partial: "[data-js-partial]",
  sidebar: "[data-js-sidebar]",
  mainArea: ".collection__main-area",
  infiniteScrollContainer: "[data-infinite-scroll-container]",
  infiniteScrollTrigger: "[data-infinite-scroll-trigger]",
};

section("collection", {
  infiniteScroll: null,
  onLoad() {
    const { paginationType } = this.container.dataset;
    this.partial = qs(sel.partial, this.container);
    this.sidebar = sidebar(qs(sel.sidebar, this.container));
    this.mainArea = qs(sel.mainArea, this.container);
    this.pageHeader = qs("[data-section-type='header']");

    this.paginationType = paginationType;
    this.paginated = this.paginationType === "paginated";
    this.infiniteScrollTrigger = qs(sel.infiniteScrollTrigger, this.container);

    this.mobileFiltering = mobileFiltering(this.container);

    this.filterHandler = filterHandler({
      container: this.container,
      partial: this.partial,
      renderCB: this.__renderView.bind(this),
    });
    this.animateGrid = animateGrid(this.container);

    this._initInfiniteScroll();
  },

  __renderView(searchParams) {
    const url = `${window.location.pathname}?section_id=${this.container.dataset.sectionId}&${searchParams}`;
    const loading = qs(".collection__loading", this.container);

    add(loading, "is-active");

    fetch(url, { credentials: "include" })
      .then(res => res.text())
      .then(res => {
        this._updateURLHash(searchParams);
        const doc = new window.DOMParser().parseFromString(res, "text/html");
        const contents = qs(sel.partial, doc).innerHTML;
        this.partial.innerHTML = contents;

        if (!this.paginated) {
          this.infiniteScrollTrigger.innerHTML = "";

          this._initInfiniteScroll();
        }

        remove(loading, "is-active");
        emit("collection:updated");
        this._scrollToTop();
      })
      .then(() => {
        this.animateGrid?.setupProductItems();
      });
  },

  _initInfiniteScroll() {
    if (this.paginated) return;
    const infiniteScrollOptions = {
      container: sel.infiniteScrollContainer,
      pagination: sel.infiniteScrollTrigger,
      loadingText: "Loading...",
      callback: () => {
        emit("collection:updated");

        this.animateGrid?.setupProductItems();
      },
    };

    if (this.paginationType === "click") {
      infiniteScrollOptions.method = "click";
    }

    this.infiniteScroll = new Ajaxinate(infiniteScrollOptions);
  },

  _scrollToTop() {
    const topOfGrid = this.mainArea.offsetTop;
    const headerHeight = this.pageHeader.offsetHeight;
    const destination = topOfGrid - headerHeight - 20;

    if (document.documentElement.scrollTop > destination) {
      window.scrollTo({ top: destination, behavior: "smooth" });
    }
  },

  _updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  },

  onUnload() {
    this.infiniteScroll && this.infiniteScroll.destroy();
  },
});
